<template>
  <div>
    <Head title="Termine" />
    <div class="flex justify-between flex-wrap">
      <h1 class="mb-8 text-3xl font-bold flex items-center text-orfBlue-100">
        <HeroIcon name="rectangle-stack" class="mr-2 h-10 w-10 fill-orfBlue-100" />
        Deine Termine
      </h1>
      <loading-button text="Termin erstellen" icon-name="add" icon-custom-icon func="link" href="/events/create" class="mb-4 sm:mb-0"/>
    </div>
    <div class="flex items-center py-4 justify-end w-full">
      <search-filter v-model="form.type" :show-filter="true" :show-reset="true" class="" @reset="reset">
        <div class="flex items-center">
          <div class="flex items-center">
            <label class="text-gray-700 mr-3">Art:</label>
            <select v-model="form.type" class="form-select w-40">
              <option selected :value="null" >Alle</option>
              <option selected value="büro" >Büro</option>
              <option selected value="urlaub" >Urlaub</option>
            </select>
          </div>
        </div>
      </search-filter>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <div class="w-full">
        <div class="flex items-center font-bold">
            <div class="pb-4 pt-6 px-6 w-72">Datum</div>
            <div class="pb-4 pt-6 px-6 flex-grow">Art</div>
            <div class="pb-4 pt-6 px-6 w-72 text-right">Optionen</div>
        </div>
        <div class="flex flex-col text-sm">
          <div v-for="event in events.data" :key="event.id" class="flex items-center border-t w-full hover:bg-gray-100 focus-within:bg-gray-100">
            <div class="flex w-72 flex-wrap">
              <Link v-if="event.type == 'urlaub'" class="sm:text-sm text-xxs flex items-center px-6 py-4 focus:text-orfBlue-500" :href="`/events/${event.id}/edit`">
                {{ formatDateTime(event.start, 'LL') }} - {{formatDateTime(event.end, 'LL')}}
              </Link>
              <Link v-else class="flex items-center px-6 py-4 focus:text-orfBlue-500" :href="`/events/${event.id}/edit`">
                {{ formatDateTime(event.start, 'LL') }}
              </Link>
            </div>
            <div class="flex flex-grow">
              <Link class="flex items-center px-6 capitalize py-4 focus:text-orfBlue-500" :href="`/events/${event.id}/edit`">
                <HeroIcon :name="event.type" class="h-5 w-5 mr-1" custom-icon :fill="event.type == 'urlaub' ? '#46A257' : event.type == 'homeoffice' ? '#27AE60' : '#3498DB'"/>
                {{event.type}}
              </Link>
            </div>
            <div class="flex justify-end items-center w-72">
              <loading-button text="Bearbeiten" icon-name="pencil-square" icon-mini func="link" small inverted :href="`/events/${event.id}/edit`"/>
            </div>
          </div>
          <div v-if="events.data.length === 0">
            <div class="px-6 py-4 border-t" colspan="4">No events found.</div>
          </div>
        </div>
      </div>
    </div>
    <pagination class="mt-6" :links="events.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import HeroIcon from '@/Shared/HeroIcon.vue'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import moment from 'moment'
import LoadingButton from '@/Shared/LoadingButton.vue'
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import mapValues from "lodash/mapValues";

export default {
  components: {
    LoadingButton,
    Head,
    HeroIcon,
    Link,
    Pagination,
  },
  layout: Layout,
  props: {
    events: Object,
    filters: Object,
  },
  data() {
    return {
      form: {
        type: this.filters.type,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        if (this.form.type == null){
          this.reset()
        } else {
          this.$inertia.reload({data: pickBy(this.form), preserveState: true})
        }
      }, 150),
    },
  },
  methods: {
    reset() {
      this.$inertia.get('events')
    },
    formatDateTime: function (date, format) {
      return moment(date).format(format)
    },
  },
}
</script>
